module.exports = __webpack_public_path__ + "img/edge_activites_rando_demi_jouernee.fcfa8bff.svg";